import { forwardRef } from 'react';

import { Link, type LinkProps } from '@/components/Link';
import { INTERVIEW_PATH } from '@/features/interview';

export const LinkInterview = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to: _to, ...rest }, ref) => {
    const to = `${INTERVIEW_PATH}${_to}`;
    return <Link ref={ref} to={to} {...rest} />;
  }
);

LinkInterview.displayName = 'LinkInterview';
``;
